import Vue from 'vue'
import rootVue from "@app2/app"

Vue.directive('click-away', {
  bind(el, binding, vnode) {
    el.clickOutsideEvent = (event) => {
      //console.log(event.target,el,binding,vnode)
      // workaround: this condition is targetting the dropdown daterangepicker only to avoid closing the dropdown when selecting dates
      if((!event.target.id && !event.target.className) || (typeof event.target.className === 'string' && (event.target.className.includes('mx') || event.target.closest('.searchie-calendar')))) return

      if (!(el == event.target || el.contains(event.target)))
        vnode.context[binding.expression] = false
    };
    document.body.addEventListener("click", el.clickOutsideEvent)
  },
  unbind(el) {
    document.body.removeEventListener('click', el.clickOutsideEvent)
  }
})

Vue.directive('popover-click-away', {
  bind(el, binding, vnode) {
    el.clickOutsideEvent = (event) => {
      if (event.target.classList.contains('popover-dropdown-search')) return // dont hide popover
      if(el.id === 'date-filter') return
      rootVue.$emit('bv::hide::popover', el.id)
      vnode.context.$root.$emit('bv::hide::popover', el.id) // works on content editor
    };
    // this ensures that the popover is hidden when clicking on an iframe, not only on the body
    el.windowBlurEvent = () => {
      rootVue.$emit('bv::hide::popover', el.id)
      vnode.context.$root.$emit('bv::hide::popover', el.id)
    };
    document.body.addEventListener("click", el.clickOutsideEvent)
    window.addEventListener("blur", el.windowBlurEvent)
  },
  unbind(el) {
    document.body.removeEventListener('click', el.clickOutsideEvent)
    window.removeEventListener('blur', el.windowBlurEvent)
  }
})

/**
 * v-drag-position directive
 * Makes an element draggable to reposition it within the viewport bounds.
 * (Not for list reordering - use vuedraggable component for that)
 *
 * Usage:
 *   <div v-drag-position>...</div>
 *   <div v-drag-position="{ padding: 16 }">...</div>
 *   <div v-drag-position="{ ignoreSelector: 'button, a' }">...</div>
 *
 * Options:
 *   - padding: Number - viewport edge padding in pixels (default: 8)
 *   - ignoreSelector: String - CSS selector for elements that should not initiate drag (default: 'button')
 *
 * Exposed methods on element:
 *   - el._clampToViewport() - Clamps element back into viewport (useful after resize/content changes)
 */
Vue.directive('drag-position', {
  bind(el, binding) {
    const options = binding.value || {};
    const padding = options.padding ?? 8;
    const ignoreSelector = options.ignoreSelector ?? 'button';

    let dragState = {
      isDragging: false,
      startX: 0,
      startY: 0,
      initialX: 0,
      initialY: 0,
      rect: null
    };

    const onMouseDown = (e) => {
      if (ignoreSelector && e.target.closest(ignoreSelector)) return;

      dragState.isDragging = true;
      dragState.rect = el.getBoundingClientRect();
      dragState.startX = e.clientX;
      dragState.startY = e.clientY;

      const transform = el.style.transform;
      const match = transform.match(/translate3d\(([^,]+),\s*([^,]+)/);
      dragState.initialX = match ? parseFloat(match[1]) : 0;
      dragState.initialY = match ? parseFloat(match[2]) : 0;

      el.classList.add('is-dragging');
      el.style.transition = 'none';
      document.addEventListener('mousemove', onMouseMove);
      document.addEventListener('mouseup', onMouseUp);
    };

    const onMouseMove = (e) => {
      if (!dragState.isDragging) return;

      const { width, height, left, top } = dragState.rect;

      let newX = dragState.initialX + (e.clientX - dragState.startX);
      let newY = dragState.initialY + (e.clientY - dragState.startY);

      // Constrain to viewport with padding
      const minX = padding - left + dragState.initialX;
      const maxX = window.innerWidth - width - padding - left + dragState.initialX;
      const minY = padding - top + dragState.initialY;
      const maxY = window.innerHeight - height - padding - top + dragState.initialY;

      newX = Math.max(minX, Math.min(maxX, newX));
      newY = Math.max(minY, Math.min(maxY, newY));

      el.style.transform = `translate3d(${newX}px, ${newY}px, 0)`;
    };

    const onMouseUp = () => {
      dragState.isDragging = false;
      el.classList.remove('is-dragging');
      el.style.transition = '';
      document.removeEventListener('mousemove', onMouseMove);
      document.removeEventListener('mouseup', onMouseUp);
    };

    el.addEventListener('mousedown', onMouseDown);

    // Expose method to clamp element back into viewport
    el._clampToViewport = () => {
      const rect = el.getBoundingClientRect();
      const dx = Math.min(0, window.innerWidth - rect.right - padding) || Math.max(0, padding - rect.left);
      const dy = Math.min(0, window.innerHeight - rect.bottom - padding) || Math.max(0, padding - rect.top);
      if (dx || dy) {
        const match = el.style.transform.match(/translate3d\(([^,]+),\s*([^,]+)/);
        const x = (match ? parseFloat(match[1]) : 0) + dx;
        const y = (match ? parseFloat(match[2]) : 0) + dy;
        el.style.transform = `translate3d(${x}px, ${y}px, 0)`;
      }
    };

    el._draggableCleanup = () => {
      el.removeEventListener('mousedown', onMouseDown);
      document.removeEventListener('mousemove', onMouseMove);
      document.removeEventListener('mouseup', onMouseUp);
    };
  },
  unbind(el) {
    if (el._draggableCleanup) {
      el._draggableCleanup();
    }
  }
})
